import { camelCase, mapKeys } from 'lodash';

export default function camelizeKeys<T>(object: Record<string, T>) {
  return mapKeys(object, (_, key) => camelCase(key));
}
